import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ConnectorCreate from '../components/ConnectorSettings/ConnectorCreate';
import {
  createConnector,
  testConnectorCredentials,
} from 'js/actions/connector-actions';
import { queryIssueFields } from 'js/actions/jira-connector-actions';
import { selectActiveWorkspace } from 'js/store/reducers/workspaces';
import { useNotify } from 'js/hooks/useNotify';

function ConnectorCreateContainer({
  createConnector,
  testConnectorCredentials,
  queryIssueFields,
  activeWorkspace,
  history,
  match,
}) {
  // Check if we have a serviceId in the URL for direct configuration
  const notify = useNotify();
  const serviceId = match.params.serviceId;
  const [currentStep] = useState(serviceId ? 2 : 1);
  const [selectedType] = useState(serviceId || '');

  const workspaceId = activeWorkspace?.id;

  const handleBack = () => {
    // Navigate back to service selection
    history.push(match.url.replace(`/${serviceId}`, ''));
  };

  const handleSubmit = useCallback(
    async (formValues) => {
      try {
        await createConnector(workspaceId, formValues);
        notify({
          type: 'success',
          message: 'Connector created successfully',
        });
        // Navigate back to connectors list
        history.push(match.url.replace('/new', ''));
      } catch (error) {
        notify({
          type: 'danger',
          message:
            'Failed to create connector. Please check your configuration.',
        });
      }
    },
    [workspaceId, createConnector, notify, history, match.url]
  );

  const handleCancel = () => {
    history.push(match.url.replace('/connectors/new', ''));
  };

  const handleTestConnector = useCallback(
    async (testData) => {
      if (!workspaceId) {
        throw new Error('No workspace selected');
      }

      try {
        const result = await testConnectorCredentials(workspaceId, testData);
        return result;
      } catch (error) {
        throw error;
      }
    },
    [workspaceId, testConnectorCredentials]
  );
  return (
    <ConnectorCreate
      currentStep={currentStep}
      selectedType={selectedType}
      onBack={handleBack}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      onTest={handleTestConnector}
      workspace={activeWorkspace}
      onQueryIssueFields={queryIssueFields}
    />
  );
}

const mapStateToProps = (state) => ({
  activeWorkspace: selectActiveWorkspace(state),
});

export default withRouter(
  connect(mapStateToProps, {
    createConnector,
    testConnectorCredentials,
    queryIssueFields,
  })(ConnectorCreateContainer)
);
